let ENV = require("../../config/env");
let port = ""; // 平台端口
let cmsHost = ""; // 平台ip
let isImgGlass = false;//为true时为毛玻璃  反之false
let oldApiHost = "";//视讯
let onlineApi = "";// 外网ipi
let apiHost = ""; // 后端api
let redisHost = "";
let chatServiceServer = "";// 聊天
let chatServiceIpWithPort = "";// 聊天
let fileServerPort = "";// 文件服务器
let fileServerIp = ""; // 文件服务器IP
let fileServerHostname = ""; // 文件服务器域名
let fileServiceOrigin = "";
let signHost = "";// 手机端网址
let domainType = "";
let liveApi = "";//直播
let loginHost = "";//登录中心
let education = ""; //远程教学项目
let baseUrl = ""; //卡易影像路径
let websocketHost = "";
let redisPort = "";
let onlineApiHost ="";
switch (ENV) {
    case "dev": {
        /**
         * 本地开发
         */
        onlineApiHost = "http://cs.api.haiyizhilian.com/hyh-public-api"
        redisPort ="6379";
        education = "http://cseducation.haiyizhilian.com";
        signHost = "http://localhost:8000";
        loginHost = "http://account.test.haiyizhilian.com";//登录中心
        port = "4002"; // 平台端口
        cmsHost = "localhost"; // 平台ip
        isImgGlass = false;//为true时为毛玻璃  反之false
        oldApiHost = "http://web.haiyizhilian.com";//视讯
        onlineApi = "http://cs.api.haiyizhilian.com/hyh-public-api";// 外网ipi
        apiHost = "http://cs.interface.haiyizhilian.com/hyh-system"; // 后端api
        redisHost = "localhost";
        chatServiceServer = "http://chat.haiyizhilian.com";// 聊天
        chatServiceIpWithPort = "http://chat.haiyizhilian.com";// 聊天
        liveApi = "http://172.16.36.90";
        fileServerPort = "80";// 文件服务器
        fileServerIp = "cs.file.haiyizhilian.com";// 文件服务器IP
        fileServerHostname = "https://cs.file.haiyizhilian.com"; // 文件服务器域名
        fileServiceOrigin = fileServerHostname;
        domainType = "local";
        break;
    }

    case "devServer": {
        /**
         *
         * 测试机开发
         */
        onlineApiHost = "http://cs.api.haiyizhilian.com"
        redisPort="6379";
        education = "http://cseducation.haiyizhilian.com";
        signHost = "http://172.16.33.85:8000";

        // loginHost = "http://localhost:3006";//登录中心   启动的是本地的单点登录

        isImgGlass = false;//为true时为毛玻璃  反之false
        port = "4002"; // 平台端口
        cmsHost = "localhost"; // 平台ip
        oldApiHost = "http://web.haiyizhilian.com";//视讯

        // apiHost = "http://interface.haiyizhilian.com/doctor"; // 后端api(医生端测试库API) 正式库接口地址 慎用！
        // onlineApi = "http://xhdoctor.interface.haiyizhilian.com";// 外网ipi
        onlineApi = "http://172.16.33.148:8080";// 外网ipi
        // apiHost = "http://xhdoctor.interface.haiyizhilian.com"; // 后端api(医生端测试库API)

        // onlineApi = "http://172.16.33.85:9001";// 外网ipi http://172.16.33.99:9001/

        apiHost = "http://172.16.36.141:7003/doctor"; // 后端api
        websocketHost = "xhdoctor.interface.haiyizhilian.com";

        redisHost = "172.16.33.85";
        chatServiceServer = "http://chat.haiyizhilian.com";// 聊天
        chatServiceIpWithPort = "http://chat.haiyizhilian.com";// 聊天
        liveApi = "http://172.16.36.90";
        fileServerPort = "80";// 文件服务器
        fileServerIp = "cs.file.haiyizhilian.com";// 文件服务器IP
        fileServerHostname = "https://cs.file.haiyizhilian.com"; // 文件服务器域名
        fileServiceOrigin = fileServerHostname;
        domainType = "ceshi";
        break;
    }

    case "demo": {
        /**
         * 医生端 项目 -》文件服务器+数据暂用测试库，redis暂用测试库redis ，当前第三方接口统一调用测试库第三方接口
         */
        baseUrl = "http://query.kayicloud.com/CloudImageformalForm.aspx?username=";
        redisPort="18017";
        education = "http://cseducation.haiyizhilian.com";
        signHost = "http://test.sign.haiyizhilian.com";
        loginHost = "http://account.demo.haiyizhilian.com";//登录中心
        isImgGlass = false;//为true时为毛玻璃  反之false
        port = "18016"; // 平台端口
        cmsHost = "192.168.1.35"; // 平台ip
        oldApiHost = "http://172.16.0.5";//视讯
        onlineApi = "http://192.168.1.35:18012";// 外网ipi
        apiHost = "http://192.168.1.35:18014"; // 后端api
        redisHost = "192.168.1.35";
        chatServiceServer = "http://chat.haiyizhilian.com";// 聊天
        chatServiceIpWithPort = "http://192.168.1.35:6004";// 聊天
        fileServerPort = "18011";// 文件服务器
        fileServerIp = "192.168.1.35"; // 文件服务器IP
        liveApi = "http://58.23.3.82:8800";
        websocketHost = "xhdoctor.interface.haiyizhilian.com";
        fileServerHostname = "https://cs.file.haiyizhilian.com"; // 文件服务器域名
        fileServiceOrigin = fileServerHostname;
        // onlineApiHost = "http://cs.api.haiyizhilian.com"; //大文件上传 配置的 上传域名
        onlineApiHost = "https://fjsfy.haiyizhilian.com/interface"; //大文件上传 配置的 上传域名
        domainType = "ceshi";
        break;
    }

    case "production": {
        /**
         * 医生端 项目 -》文件服务器+数据用正式库，redis用正式库redis ，当前第三方接口统一调用正式第三方接口
         */

        baseUrl = "http://query.kayicloud.com/CloudImageformalForm.aspx?username=";
        redisPort="8010";
        education = "http://cseducation.haiyizhilian.com";
        signHost = "http://test.sign.haiyizhilian.com";
        loginHost = "http://account.demo.haiyizhilian.com";//登录中心
        isImgGlass = false;//为true时为毛玻璃  反之false
        port = "8004"; // 平台端口
        cmsHost = "192.168.0.127"; // 平台ip
        oldApiHost = "http://172.16.0.5";//视讯
        onlineApi = "http://192.168.0.127:8003";// 外网ipi
        apiHost = "http://192.168.0.127:8001/doctor"; // 后端api
        redisHost = "192.168.0.127";
        chatServiceServer = "http://chat.haiyizhilian.com";// 聊天
        chatServiceIpWithPort = "http://192.168.0.127:6004";// 聊天
        fileServerPort = "80";// 文件服务器
        fileServerIp = "file.haiyizhilian.com"; // 文件服务器IP
        liveApi = "http://58.23.3.82:8800";
        websocketHost = "interface.haiyizhilian.com/doctor";
        fileServerHostname = "https://file.haiyizhilian.com"; // 文件服务器域名
        fileServiceOrigin = fileServerHostname;
        onlineApiHost = "https://fjsfy.haiyizhilian.com/interface" //大文件上传 配置的 上传域名
        domainType = "zhengshi";
        break;
    }
}
let hosts = {
    websocketHost,
    education,
    loginHost,
    cmsHost,
    signHost,
    port,
    redisPort,
    redisHost,
    fileServerIp,
    fileServiceOrigin,
    fileServerPort,
    isImgGlass,
    chatServiceIpWithPort,
    chatServiceServer,
    onlineApi,
    apiHost,
    oldApiHost,
    domainType,
    liveApi,
    baseUrl,
    onlineApiHost
};
module.exports = hosts;



// WEBPACK FOOTER //
// ./public/config/host-conf.js